/**
 * Enum for the LeaseSeasonGrid Context
 */
 enum LeaseSeasonGridContextType {
    /**
     * Listing Context
     */
    Listing = 0,
  
    /**
     * Lease Context
     * 
     */
    Lease = 1,
   
  }
  
  export default LeaseSeasonGridContextType;
  